<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit">
          添加
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item class="pr-10">
            <el-input
              v-model.trim="queryForm.title"
              clearable
              placeholder="请输入名称"
            />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="queryForm.levelId"
              clearable
              placeholder="请选择会员等级"
            >
              <el-option
                v-for="item in levels"
                :key="item.levelId"
                :label="item.title"
                :value="item.levelId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table
      v-loading="listLoading"
      border
      :data="list"
      @selection-change="setSelectRows"
    >
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="会员等级"
        prop="level.title"
        width="160px"
      />
      <el-table-column
        align="left"
        label="名称"
        prop="basic.title"
        width="160px"
      />
      <el-table-column align="left" label="图标" prop="basic.avatar">
        <template #default="{ row }">
          <img class="avatar" :src="row.basic.avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        width="160px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="85"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { delLevelIcon, getLevelIcons, getAllLevels } from '@/api/people'
  import Edit from './edit'

  export default {
    name: 'PeopleLevelIcon',
    components: { Edit },
    data() {
      return {
        moment,
        levels: [],
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        queryForm: {
          page: 1,
          size: 10,
          title: '',
          levelId: '',
        },
      }
    },
    created() {
      this.fetchData()
      this.getLevels()
    },
    methods: {
      async getLevels() {
        this.levels = await getAllLevels()
      },
      setSelectRows(val) {
        this.selectRows = val
      },
      handleEdit(row) {
        if (row.levelIconId) {
          this.$refs['edit'].showEdit(row)
        } else {
          this.$refs['edit'].showEdit()
        }
      },
      handleDelete(row) {
        if (row.levelIconId) {
          this.$baseConfirm(
            `你确定要删除：${row.basic.title}吗`,
            null,
            async () => {
              await delLevelIcon({ levelIconId: row.levelIconId })
              this.$baseMessage(
                '删除会员图标成功',
                'success',
                false,
                'vab-hey-message-success'
              )
              await this.fetchData()
            }
          )
        }
      },
      handleSizeChange(val) {
        this.queryForm.size = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      queryData() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const { list, total } = await getLevelIcons(this.queryForm)
        this.list = list
        this.total = total
        this.listLoading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 40px;
    height: 40px;
  }
  .pr-10 {
    padding-right: 10px;
  }
</style>
